import "./sharepost.scss";
import CancelIcon from '@mui/icons-material/Cancel';
import { useShareLogic } from "./hooks/useShareLogic";
import SharePreview from "./components/SharePreview";
import MediaGrid from "./components/MediaGrid";
import ShareActions from "./components/ShareActions";

const Sharepost = ({ setOpenShare, postToShare }) => {
    const { 
        desc, 
        setDesc, 
        handleShareFeed, 
        isLoading, 
        previewData,
        postType,
        setPostType
    } = useShareLogic(postToShare, setOpenShare);

    return (
        <div className="sharepost" onClick={() => setOpenShare(false)}>
            <div className="wrapper" onClick={(e) => e.stopPropagation()}>
                <div className="container">
                    <div className="top">
                        <h1>
                          Share post
                        </h1>

                        <button className="close" onClick={() => setOpenShare(false)}>
                            <CancelIcon />
                        </button>
                    </div>

                    <hr />

                    <div className="shareInput">
                        <div className="sharePostTypeContainer" style={{ marginBottom: "10px" }}>
                            <select 
                                value={postType} 
                                onChange={(e) => setPostType(e.target.value)}
                            >
                                <option value="Discussion">
                                    Discussion
                                </option>

                                <option value="Question">
                                    Question
                                </option>

                                <option value="Proof attempt">
                                    Proof attempt
                                </option>

                                <option value="Counterexample">
                                    Counterexample
                                </option>

                                <option value="Research idea">
                                    Research idea
                                </option>
                            </select>
                        </div>

                        <textarea 
                            placeholder="Write something about this..." 
                            onChange={(e) => setDesc(e.target.value)}
                            value={desc}
                        />
                    </div>

                    <SharePreview data={previewData} />

                    <hr />

                    <ShareActions 
                        onShare={handleShareFeed} 
                        isLoading={isLoading} 
                    />

                </div>
            </div>
        </div>
    );
};

export default Sharepost;